import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Editor from './editor'
import List from './list'
import layout from '../layout.vue'

const basePath = '/v-admin/company-policy-management'

export default {
  component: layout,
  path: basePath,
  redirect: `${basePath}/list`,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_HR_COMPANY_POLICY_MANAGEMENT'],
    titleI18nKey: 'admin.company.agreement.title',
    menu: {
      get label () {
        return i18n.t('admin.company.agreement.title')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.agreement.title'
      }
    },
    {
      path: `${basePath}/edit/:policyId`,
      component: Editor,
      meta: {
        permission: ['PERM_HR_COMPANY_POLICY_MANAGEMENT'],
        isView: false,
        isEdit: true,
        titleI18nKey: 'admin.company.agreement.title',
        menu: {
          get label () {
            return i18n.t('admin.company.agreement.title')
          }
        }
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isView: false,
        permission: ['PERM_HR_COMPANY_POLICY_MANAGEMENT'],
        titleI18nKey: 'admin.company.agreement.title',
        menu: {
          get label () {
            return i18n.t('admin.company.agreement.title')
          }
        }
      }
    },
    {
      path: `${basePath}/view/:policyId`,
      component: Editor,
      meta: {
        isView: true,
        permission: ['PERM_HR_COMPANY_POLICY_MANAGEMENT'],
        titleI18nKey: 'admin.company.agreement.title',
        menu: {
          get label () {
            return i18n.t('admin.company.agreement.title')
          }
        }
      }
    }
  ]
}
